import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PortugalFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15757'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15757)'>
				<rect
					width='20'
					height='14'
					fill='#FF2936'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H7.61905V0H0V14Z'
					fill='#128415'
				/>
				<path
					d='M7.61961 9.5333C9.02701 9.5333 10.191 8.41172 10.191 6.99997C10.191 5.58821 9.02701 4.46663 7.61961 4.46663C6.21221 4.46663 5.04818 5.58821 5.04818 6.99997C5.04818 8.41172 6.21221 9.5333 7.61961 9.5333Z'
					stroke='#FAF94F'
					strokeWidth='1.33333'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 5.93331C6.66602 5.74921 6.81525 5.59998 6.99935 5.59998H8.23744C8.42154 5.59998 8.57078 5.74921 8.57078 5.93331V7.4476C8.57078 7.97358 8.14438 8.39998 7.6184 8.39998C7.09241 8.39998 6.66602 7.97358 6.66602 7.44759V5.93331Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61877 7.46665C7.88176 7.46665 8.09496 6.79105 8.09496 6.53332C8.09496 6.27558 7.88176 6.06665 7.61877 6.06665C7.35578 6.06665 7.14258 6.27558 7.14258 6.53332C7.14258 6.79105 7.35578 7.46665 7.61877 7.46665Z'
					fill='#1D50B5'
				/>
			</g>
		</svg>
	);
};

export default PortugalFlagIcon;
